import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { translate } from '../../Services/translation';
import Dropdown, { DropdownOption } from '../Dropdown';
import { onSortItemSelected } from '../../Actions/ProductFiltering.action';
import { setProductListingType } from '../../Actions/ProductListing.action';
import Icon from '../Icon';
import { ProductListingType } from '../../Reducers/ProductListing.reducer';
import FilterBarButtons from './FilterBarButtons';
import clsx from 'clsx';

const FilterBar = () => {
  const dispatch = useDispatch();
  const { totalProductsCount, productListingType } = useTypedSelector(
    (state) => state.productListing
  );
  const sortItems = useTypedSelector(
    (state) => state.productFiltering.sortCriteria?.sortItems
  );

  const onSortingChanged = (selectedOption: DropdownOption) => {
    const sortItem = sortItems?.find(
      (s) => s.query == selectedOption.value
    );
    if (!sortItem) return;

    dispatch(onSortItemSelected(sortItem));
  };

  return (
    <>
      <FilterBarButtons />
      <div className="mb-4 flex items-center justify-between lg:mb-6">
        <div className="text-md text-gray-600">
          {totalProductsCount}{' '}
          {translate('general.products').toLowerCase()}
        </div>
        <div className="flex items-center gap-4">
          <div className="flex gap-4">
            <Icon
              name="grid-view"
              className={clsx(
                'grid-icon h-[1.5rem] w-[1.5rem] cursor-pointer',
                productListingType == ProductListingType.Grid
                  ? 'text-black'
                  : 'text-gray-500'
              )}
              onClick={() =>
                dispatch(setProductListingType(ProductListingType.Grid))
              }
            />
            <Icon
              name="view-agenda"
              className={clsx(
                'grid-icon hidden h-[1.5rem] w-[1.5rem] cursor-pointer md:block',
                productListingType == ProductListingType.List
                  ? 'text-black'
                  : 'text-gray-500'
              )}
              onClick={() =>
                dispatch(setProductListingType(ProductListingType.List))
              }
            />
            <Icon
              name="square"
              className={clsx(
                'grid-icon hidden h-[1.5rem] w-[1.5rem] cursor-pointer md:hidden',
                productListingType == ProductListingType.Grid
                  ? 'text-black'
                  : 'text-gray-500'
              )}
              onClick={() =>
                dispatch(
                  setProductListingType(ProductListingType.SingleCard)
                )
              }
            />
          </div>
          {sortItems && (
            <div className="hidden w-[200px] bg-white lg:block">
              <Dropdown
                options={sortItems.map((item) => ({
                  value: item.query,
                  label: item.name,
                }))}
                selectedValue={sortItems.find((s) => s.selected)?.query}
                onChange={onSortingChanged}
                size="small"
                disableInitialTrigger={true}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FilterBar;
